import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authtoken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const AppointmentApi = createApi({
  reducerPath: 'AppointmentApi',
  baseQuery,
  tagTypes: ['Appointment'],
  endpoints: (builder) => ({
    getAppointments: builder.query({
      query: () => ({
        url: `/member/gym-appointments/`,
        method: 'GET',
      }),
      providesTags: ['Appointment'],
    }),
  }),
});

export const { useGetAppointmentsQuery } = AppointmentApi;
